var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canViewVerticalNavMenuLink(_vm.item))?_c('li',{staticClass:"nav-item",class:{
    active: _vm.isActive,
    disabled: _vm.item.disabled,
  }},[_c('b-link',_vm._b({staticClass:"d-flex align-items-center"},'b-link',_vm.linkProps,false),[_c('mdicon',{attrs:{"name":_vm.item.icon}}),_c('span',{staticClass:"menu-title text-truncate"},[_vm._v(_vm._s(_vm.t(_vm.item.title)))])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }